export const Constants = {
  shouldUseNativeDriver: !process.env.JEST_WORKER_ID,
};
